
// region JS Imports

// region External Modules
import u from "umbrellajs"
import serialize from "form-serialize"

import I18n from "plugins/i18n-js"
// endregion External Modules

// Private Modules
import Notifier from "app/notifier/index"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


// unused?
// deprecated logic? //hide div?
const default_selector = {
  main: ".cell--mobile-apps--searcher-app--download-link",
  box:  ".cell--mobile-apps--searcher-app--download-link__actions--get",
  form: "form.send_searcher_app_link",
}

const initPhoneInput = (selector: object) => {
  const sele = Object.assign({}, default_selector, selector)
  const $el = u(sele.main)
  const $searcher_app_box = $el.find(sele.box)
  const $form = $el.find(sele.form)
  const $lister_app_form_selector_phone_input = $form.find("#phone_number")

  $lister_app_form_selector_phone_input.on("click", () =>
    $searcher_app_box.removeClass("lister-app--sms-sent")
  )

}

const initAjax = (selector: object) => {
  const sele = Object.assign({}, default_selector, selector)
  const $el = u(sele.main)
  const $searcher_app_box = $el.find(sele.box)
  const $form = $el.find(sele.form)
  const form_el = $form.first() as HTMLFormElement

  $form.on("submit", (e) => {
    e.preventDefault()

    q_ajax_3({
      url:    $form.attr("action"),
      method: "POST",
      data:   serialize(form_el, {hash: true}),
    })
    .then(() => {
      Notifier.showSuccess(I18n.t("js.app.notifier.send_sms.successfully_submitted"))

      $searcher_app_box.addClass("searcher-app--sms-sent")
    })
    .catch(() => {
      Notifier.showWarning(I18n.t("js.app.notifier.send_sms.reenter_phone"))
    })
    .done()
  })
}


const init = (selector: object = {}) => {
  initPhoneInput(selector)
  initAjax(selector)
}


export default {init}
